var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 545.053,
    height: 194.173,
    viewBox: "0 0 545.053 194.173",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "green-band",
    transform: "translate(-572.969 -87.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    d: "M518.9,0H26.1A26.055,26.055,0,0,0,0,26.014v165.1c6.691-24.68,29.508-75.241,67.246-80.044s324.857-2,386.416,0c15.389.667,81.3,5,91.335-48.026V26.014A26.055,26.055,0,0,0,518.9,0Z",
    transform: "translate(573.002 91)",
    fill: "#aad3b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    d: "M493,0H0C-14.644-1.034-26.749,10.634-26,26V187c6.667-24.667,29.4-75.2,67-80s325.665-2,387,0c15.333.667,81,5,91-48V26C519.53,13.626,510.968-.654,493,0Z",
    transform: "translate(599.002 88)",
    fill: "#e4f7e9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowest);
export default __webpack_public_path__ + "static/media/lowest.58539c55c4ac2c5ea3345c650e347adf.svg";
export { ForwardRef as ReactComponent };